import React from 'react'
import { Text } from '../../../generic'
import { CREDIT_WORTHINESS_TIPS } from '../../../../constants/creditWorthinessTips'

function CreditWorthinessTip({ tip }) {
  if (!tip || !tip.name) return null

  const description = CREDIT_WORTHINESS_TIPS[tip.name] || tip.name

  return (
    <div style={{
      background: '#FFFFFF',
      boxShadow: 'inset 0px 0px 10px rgba(64, 67, 87, 0.08)',
      borderRadius: '4px',
      padding: '12px 16px',
      marginBottom: '12px'
    }}>
      <Text size={13} color="text" style={{ lineHeight: '20px' }}>
        {description}
      </Text>
    </div>
  )
}

export default CreditWorthinessTip
